import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import worlds from '../worlds';
import InfoWrapper from './InfoWrapper';
import InfoField from './InfoField';
import CloseButton from './CloseButton';

const InfoDialog = ({ open, onClose, ...props }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      style: {
        marginLeft: 15,
        marginRight: 15
      }
    }}
    maxWidth={false}
    fullWidth
  >
    <DialogTitle>
      <FormattedMessage id="portfolio.challenge.world_select.world_info.title" />
    </DialogTitle>
    <DialogContent style={{ paddingBottom: 0 }}>
      <InfoWrapper>
        {worlds.map(world => (
          <InfoField world={world} key={world} />
        ))}
      </InfoWrapper>
    </DialogContent>
    <CloseButton onClick={onClose} />
  </Dialog>
);

InfoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default InfoDialog;
